import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogNonBusinessDay = ({
    day, dialog
}) => {
    return (
        <DialogAlertAction
            variant="secondary"
            title={`El ${day} fue registrado como un Día no hábil para este espacio`}
            contentComponent={
                <p className="paragraph center">
                    Recuerda que para crear una reserva manual, debes considerar una fecha que cuente con un horario de atención.
                </p>}
            show={dialog.value}
            toggleShow={dialog.toggle}
            width="700px"
            widthContent="90%">
            <CustomButton
                text="Cancelar"
                onClick={dialog.hide} />
        </DialogAlertAction>
    );
}

export default DialogNonBusinessDay;